import React, { useEffect } from "react";
import { Col, Layout, Row } from "antd";
import "./homelayout.css";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { menuService } from "../../services/services";
import { setMenuHeader } from "../../redux/actions";

const { Content } = Layout;
const EMPTY_MENUS = [];

const HomeLayout = ({ className, children, contanierClassName }) => {

	const menus = useSelector(state => state.ui.menus) || EMPTY_MENUS
	const dispatch = useDispatch()

	const getMenus = async () => {
		try {
			const { data } = await menuService.find({ query: { status: 'active', $sort: { position: 1 } } })
			dispatch(setMenuHeader(data))
		} catch (error) {
			console.error('[HomeLayout] Failed to load menus', error)
		}
	}

	useEffect(() => {
		if (!menus.length) {
			getMenus()
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [menus.length])

	return (
		<Layout className={className ? className : "home-layout"}>
			<Header />
			<Row
				type="flex"
				justify="center"
				align="middle"
				gutter={{
					xl: 18,
				}}
				className={`${contanierClassName ? contanierClassName :  "home-content"} bg-main-container`}
			>
				<Col className={contanierClassName ? contanierClassName : "home-container"} span={19}>
					<Row type="flex" justify="center" align="middle">
						<Col>{children}</Col>
					</Row>
				</Col>
			</Row>
			<Footer />
		</Layout>
	)
};
export default HomeLayout;
